module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('shared-product-edit', {
    attrs: {
      "product": _vm.product,
      "images": _vm.images
    }
  }, [_c('div', {
    staticClass: "l-col-4@md",
    attrs: {
      "slot": "attributes"
    },
    slot: "attributes"
  }, [_c('div', {
    staticClass: "margin"
  }, _vm._l((_vm.product.variationAttributes), function(attr) {
    return _c('div', {
      key: attr.id
    }, [_c('strong', [_vm._v(_vm._s(attr.label) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(attr.valueLabel))])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8553b56e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/shein/ProductEdit.vue
// module id = 3349
// module chunks = 0